<template>
  <!-- 关键字搜索页面 -->
  <el-container
    v-loading.fullscreen="loading"
    element-loading-text="加载中"
    class="index"
  >
    <el-header>
      <div class="formGroup">
        <div class="search-banner">
          <div class="mynav">
            <img src="../assets/img/logo_ZH.png" alt="Zata搜索" class="logo" />
            <div class="clearfix info">
              <el-dropdown
                trigger="click"
                class="clearfix"
                @command="handleCommand"
              >
                <img :src="headImg" alt="" class="headimg L" />
                <el-badge class="item L username">{{ userName }}</el-badge>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item command="myCollection">我的收藏</el-dropdown-item> -->
                  <el-dropdown-item command="loginout"
                    >退出登录</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <img class="level" v-if="isVip == 1" src="../assets/img/vip1.png" alt="">
              <img class="level" v-if="isVip == 2" src="../assets/img/vip2.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </el-header>
    <el-main>
      <h2>智能文献搜索</h2>
      <div class="searchTypeList">
        <el-radio-group
          @input="changeKey"
          class="searchTypeRadio"
          v-model="selectKey"
          fill="rgba(255, 255, 255, 0.20)"
          :border="false">
          <el-radio-button label="all">全部搜索</el-radio-button>
          <el-radio-button label="normal">文献搜索</el-radio-button>
          <el-radio-button label="patient">病例搜索</el-radio-button>
          <el-radio-button label="clinical">研究搜索</el-radio-button>
          <el-radio-button label="medical">药品搜索</el-radio-button>
        </el-radio-group>
      </div>
      <el-input
        placeholder="请输入关键字"
        v-model="keyword"
        class="input-with-select search-btn-box"
        @click.stop.native="showList"
        maxlength="200"
        @keyup.13.native="normalSearch"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click.stop="normalSearch"
        ></el-button>
      </el-input>
      <div class="searchList" v-show="showHisList">
        <ul v-if="hisList.length !== 0">
          <li class="clearfix" v-for="(item, index) in hisList" :key="index">
            <span class="L" @click="chooseHisKey(item.keyword)">{{
              item.keyword
            }}</span>
            <i
              class="el-icon-delete R"
              @click.prevent="deleteHis(item.keyword, item.id)"
            ></i>
          </li>
        </ul>
        <ul v-if="hisList.length === 0">
          <li class="clearfix"><span class="L">暂无历史记录</span></li>
        </ul>
      </div>
      <p class="clearfix searchTry">
        <span class="L">尝试一下：
          <!-- 文献搜索关键字 -->
          <a
            v-if="selectKey == 'normal' || selectKey == 'all'"
            href="javascript:;"
            @click="trySearch(item)"
            v-for="(item, index) in tryArrary"
            :key="index"
            >{{ item }}
          </a>
          <!-- 药品搜索关键字 -->
          <a
            v-if="selectKey == 'medical'"
            href="javascript:;"
            @click="trySearch(item)"
            v-for="(item, index) in medicalTryArrary"
            :key="index"
            >{{ item }}
          </a>
          <!-- 病例搜索关键字 -->
          <a
            v-if="selectKey == 'patient'"
            href="javascript:;"
            @click="trySearch(item)"
            v-for="(item, index) in caseTryArrary"
            :key="index"
            >{{ item }}
          </a>
          <!-- 研究搜索关键词 -->
          <a
            v-if="selectKey == 'clinical'"
            href="javascript:;"
            @click="trySearch(item)"
            v-for="(item, index) in clinicalTryArrary"
            :key="index"
            >{{ item }}
          </a>
        </span>
        <a
          v-if="selectKey == 'normal'"
          href="javascript:;"
          class="R"
          @click="toAdvance">
          精准搜索
        </a>
      </p>
      <!-- 未登录时 -->
      <div class="noLogin" v-if="token == ''">
        <div class="toLogin">
          <h2>登录一下</h2>
          <h3>发现更多精彩内容</h3>
          <el-button @click="toLogin">点击登录</el-button>
        </div>
        <img src="../assets/img/bg_img.png" alt="" />
      </div>
      <!-- 文献推荐 -->
      <div class="recommend" v-show="showRecommend" v-loading="articleLoading">
        <h3>
          <span>文献推荐</span
          ><el-button @click="getArticles">换一批</el-button>
        </h3>
        <ul>
          <li
            v-for="item in articleList"
            :key="item.pmid"
            @click="toFullText(item.pmid)"
          >
            <div class="lside">
              <p class="title">{{ item.title_cn }}</p>
              <div class="point_text">
                {{
                  `${item.pubyear}，${item.journal_abbreviation} (IF=${item.impact_factor})`
                }}
              </div>
              <div class="article">{{ item.title_en }}</div>
            </div>
            <div class="rside"><i class="el-icon-arrow-right"></i></div>
          </li>
        </ul>
      </div>
      <!-- 全部搜索结果汇总 -->
      <div class="overall" v-show="showOverall && selectKey == 'all'" v-loading="overallLoading" element-loading-background="rgba(255, 255, 255, 0.4)">
        <div class="overallItem" @click="handleToSearch('normal')">
          <div class="itemInfo">
            <img src="../assets/img/icon_overall_article.png" />
            <div class="count">{{ overall.normal }}</div>
            <div class="name">文献</div>
          </div>
          <div class="arrow">
            <img class="icon" src="../assets/img/icon_overall_arrow.png"/>
          </div>
        </div>
        <div class="overallItem" @click="handleToSearch('patient')">
          <div class="itemInfo">
            <img src="../assets/img/icon_overall_case.png" />
            <div class="count">{{ overall.patient }}</div>
            <div class="name">病例</div>
          </div>
          <div class="arrow">
            <img class="icon" src="../assets/img/icon_overall_arrow.png"/>
          </div>
        </div>
        <div class="overallItem" @click="handleToSearch('clinical')">
          <div class="itemInfo">
            <img src="../assets/img/icon_overall_research.png" />
            <div class="count">{{ overall.clinical }}</div>
            <div class="name">研究</div>
          </div>
          <div class="arrow">
            <img class="icon" src="../assets/img/icon_overall_arrow.png"/>
          </div>
        </div>
      </div>
    </el-main>
    <div class="iconList">
      <p>
        <el-popover
          placement="left"
          title=""
          width="80"
          trigger="hover"
          content="我的收藏"
        >
          <img
            class="icon"
            src="../assets/img/icon/collect.png"
            alt=""
            slot="reference"
            @click="handleCollection"
          />
        </el-popover>
      </p>
      <p>
        <el-popover
          placement="left"
          title=""
          width="80"
          trigger="hover"
          content="e药伴官网"
        >
          <img
            class="icon"
            src="../assets/img/icon/icon1.png"
            alt=""
            slot="reference"
            @click="showIndex"
          />
        </el-popover>
      </p>
      <p>
        <el-popover placement="left" title="" width="162" trigger="hover">
          <img src="../assets/img/icon/icon6.png" alt="" />
          <span>e药伴介绍，扫一扫查看</span>
          <img
            class="icon"
            src="../assets/img/icon/icon3.png"
            alt=""
            slot="reference"
          />
        </el-popover>
      </p>
      <p>
        <el-popover placement="left" title="" width="162" trigger="hover">
          <img src="../assets/img/icon/icon7.png" alt="" />
          <span>微信扫一扫，手机用文献</span>
          <img
            class="icon"
            src="../assets/img/icon/icon2.png"
            alt=""
            slot="reference"
          />
        </el-popover>
      </p>
    </div>
    <!-- <img src="../assets/pubmedSearch/code.png" alt="" class="codeImg"> -->
  </el-container>
</template>

<script>
// import { browser } from '../config/ua'
import {
  getToken,
  getRole,
  baseHistory,
  getRecommendArticles,
  getUserVip,
  getOverall
} from "../service/getData";
import { webTrackerEvent } from "../utils/tracker";
import dayjs from 'dayjs'
export default {
  name: "index",
  data() {
    return {
      loading: false,
      keyword: "",
      userName: "",
      headImg: "",
      selectKey: "all",
      tryArrary: ["冠心病危险因素", "特应性皮炎", "脆性糖尿病"],
      medicalTryArrary: ["二甲双胍", "阿托伐他汀", "紫杉醇", "Nivolumab"],
      caseTryArrary: ["糖尿病肾病", "新辅助化疗", "乳腺癌"],
      clinicalTryArrary: ['利妥昔单抗', '甘精胰岛素', '卒中', '2型糖尿病', '非小细胞肺癌'],
      showHisList: false, // 历史搜索
      pageNum: 1,
      pageSize: 10,
      search_type: "all", // 历史记录类型
      hisList: [],
      token: "",
      openid: "",
      articleLoading: false,
      articleList: [],
      isVip:undefined,// 0，1，2
      showRecommend: true,
      overallLoading: false,
      showOverall: false,
      overall: {},
    };
  },
  methods: {
    showIndex() {
      window.open("http://www.eyaoban.com/");
    },
    // 获取基本历史记录
    async getNormalSearch() {
      const params = {
        type: this.search_type,
        limit: this.pageSize,
        page: this.pageNum,
      };
      const res = await baseHistory("GET", params);
      if (res && res.data.status === 0) {
        this.hisList = res.data.data;
      } else {
        this.hisList = [];
      }
    },
    // 删除历史记录
    async deleteHis(keyword, id) {
      const params = { type: this.search_type, id: id };
      const res = await baseHistory("DELETE", params);
      if (res && res.data.status === 0) {
        let Logger = webTrackerEvent();
        Logger.push("page_url", window.location.href);
        Logger.push("action", "delete");
        Logger.push("delete_keyword", keyword);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        this.getNormalSearch();
      }
    },
    // 选择历史记录
    chooseHisKey(key) {
      if (key === "暂无历史记录") {
        return;
      }
      this.keyword = key;
    },
    showList() {
      this.showHisList = true;
    },
    async normalSearch() {
      if (this.keyword === "") {
        this.$alert("请输入要搜索的关键字", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "search");
      Logger.push("token", this.token);
      Logger.push("search_keyword", this.keyword);
      Logger.push("search_kind", this.selectKey);
      Logger.push("openid", this.openid);
      Logger.logger();

      if(this.selectKey == "all") {
        this.showOverall = true;
        this.showRecommend = false;
        this.overallLoading = true;
        const params = {
          keyword: this.keyword
        }
        const res = await getOverall(params);
        this.overallLoading = false;
        const { status,data } = res.data;
        if(status == 0) {
          const { clinical, normal, patient } = data;
          this.overall = {
            clinical,
            normal,
            patient
          }
        }
      } else if (this.selectKey === "normal") {
        this.$router.push("baseResult?key=" + encodeURIComponent(this.keyword) + "&searchType=" + this.selectKey);
      } else if (this.selectKey === "patient") {
        this.$router.push("caseList?key=" + encodeURIComponent(this.keyword) + "&searchType=" + this.selectKey);
      } else if(this.selectKey === "clinical") {
        this.$router.push("clinicalTrials?key=" + encodeURIComponent(this.keyword) + "&searchType=" + this.selectKey);
      }
      else {
        // by chenbin 2021-09-13 测试端没有此限制
        if(this.isVip == 0) {

          this.$alert("此功能仅VIP用户可以使用哦", "标题名称", {
            confirmButtonText: "确定",
          });

        } else {

          this.$router.push(
            "knowledge?key=" + encodeURIComponent(this.keyword) + "&searchType=" + this.selectKey
          );

        }

      }
    },
    /**
     * 全部搜索点击对应模块去搜索
     */
    handleToSearch(key) {

      let Logger = webTrackerEvent();
      Logger.push("page_url", window.location.href);
      Logger.push("action", "overall_item_search");
      Logger.push("token", this.token);
      Logger.push("search_keyword", this.keyword);
      Logger.push("search_kind", key);
      Logger.push("openid", this.openid);
      Logger.logger();

      if (key === "normal") {
        const { href } = this.$router.resolve("baseResult?key=" + encodeURIComponent(this.keyword) + "&searchType=" + key);
        window.open(href);
      } else if (key === "patient") {
        const { href } = this.$router.resolve("caseList?key=" + encodeURIComponent(this.keyword) + "&searchType=" + key);
        window.open(href);
      } else if(key === "clinical") {
        const { href } = this.$router.resolve("clinicalTrials?key=" + encodeURIComponent(this.keyword) + "&searchType=" + key);
        window.open(href);
      }
    },
    trySearch(key) {
      this.keyword = key;
      // this.$router.push('baseResult?key='+ this.keyword)
    },
    changeKey(val) {
      this.selectKey = val;
      if(val == "all" && this.showOverall) {
        this.showRecommend = false;
      } else {
        this.showRecommend = true;
      }

      if (val === "medical") {
        this.search_type = "drug";
      } else {
        this.search_type = val;
      }
      this.hisList = [];
      this.getNormalSearch();
    },
    handleCommand(val) {
      this.loginout();
    },
    handleCollection() {
      this.$router.push("collection");
    },
    toAdvance() {
      this.$router.push("precisionSearch");
    },
    // 获取用户角色
    async getUserRole() {
      const res = await getRole();
      if (res && res.data.status === 0) {
        // this.isVip = Number(res.data.data["is_vip"]);
        // window.localStorage.setItem("ISVIP", res.data.data["is_vip"]);
        window.localStorage.setItem("ISADMIN", res.data.data["is_admin"]);
        window.localStorage.setItem("ISEDITOR", res.data.data["is_editor"]);
      }
    },
    /**
     * 获取个人vip等级
     */
    async handleGetVip(){
      let res = await getUserVip();
      let {status,data} = res.data;
      if(status == 0) {
        let { vip2 } = data;
        let isVip = 1;// 默认1，最低级
        if(vip2) {
          let ifBefore = dayjs().isBefore(dayjs(vip2).add(1,'day'),'day');
          if(ifBefore) {
            isVip = 2;
          }
        }
        this.isVip  = isVip;
        window.localStorage.setItem("ISVIP", isVip);
      }
    },
    // 获取文献推荐
    getArticles() {
      this.articleLoading = true;
      const params = { groupName: "eMSL" };
      getRecommendArticles(params)
        .then((res) => {
          this.articleLoading = false;
          if (res.data.status == 0) {
            this.articleList = res.data.data;
          } else {
            this.articleList = [];
          }
        })
        .catch(() => {
          this.articleLoading = false;
        });
    },
    // 查看全文
    toFullText(pmid) {
      let routeData = this.$router.resolve({
        path: "fullText",
        query: {
          pmid: pmid,
          from: "recommend",
        },
      });
      let Logger = webTrackerEvent();
      Logger.push("action", "recommend_viewDetail");
      Logger.push("openid", this.openid);
      Logger.push("token", this.token);
      Logger.push("pmid", pmid);
      Logger.push("page_url", window.location.href);
      Logger.logger();
      window.open(routeData.href, "_blank");
    },
    // 去登陆
    toLogin() {
      this.$router.replace("login");
    },
    // 退出登录
    loginout() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        window.localStorage.clear();
        window.localStorage.setItem("REDIRECT", window.location.href);
        this.$router.push("login");
      }, 2000);
    },
  },
  created: function () {
    let token = window.localStorage.getItem("PUBMEDSEARCHTOKEN");
    if (token) {
      this.userName = window.localStorage.getItem("PUMMEDSEARCHUSERNAME");
      this.headImg = window.localStorage.getItem("PUMMEDSEARCHHEADIMG");
      this.token = token;
      this.openid = window.localStorage.getItem("PUBMEDSEARCHOPENID");
      this.getUserRole();
      this.handleGetVip();
      this.getNormalSearch();
      this.getArticles();
    }
  },
  mounted() {
    // window.localStorage.setItem('PUBMEDSEARCHTOKEN', '690beffbf9eede99724167d262bf7aa9fec2a6f8')
    // window.localStorage.setItem('PUBMEDSEARCHOPENID', 'oLhcYwCyi2TSc5wfA1rLtz7uEtgI')
    // window.localStorage.setItem('PUMMEDSEARCHUSERNAME', '相遇。')
    // window.localStorage.setItem('PUMMEDSEARCHHEADIMG', 'https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTIcHzURq1Bpx5CoKtWLXrtA9Amia1aPdZmYeeF1a0umfYMJwULTBKJkiaLh42d5sfTUOiadTiczNibYicLQ/132')
    // this.userName = window.localStorage.getItem('PUMMEDSEARCHUSERNAME')
    // this.headImg = window.localStorage.getItem('PUMMEDSEARCHHEADIMG')
    // this.token = window.localStorage.getItem('PUBMEDSEARCHTOKEN')
    // this.openid = window.localStorage.getItem('PUBMEDSEARCHOPENID')
    const _this = this;
    document.addEventListener("click", function () {
      _this.showHisList = false;
    });
  },
};
</script>

<style scoped>
.el-container {
  min-height: 100%;
  background: url(../assets/pubmedSearch/back3.svg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  /* overflow: hidden; */
}
.el-container >>> .el-header {
  padding: 0;
}
.formGroup {
  width: 100%;
  min-width: 1280px;
  margin: 0 auto;
  height: 100%;
}
.search-banner {
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
}
.mynav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 40px;
  height: 48px;
}
.info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.info .level {
  margin-left: 20px;
}
.mynav .logo {
  width: 104px;
  cursor: pointer;
}
.mynav .el-dropdown{
  display: flex;
  align-items: center;
}
.mynav .headimg {
  width: 36px;
  border-radius: 50%;
}
.mynav .username {
  font-size: 16px;
  margin-left: 10px;
  color: #fff;
  line-height: 50px;
}
.el-main {
  width: 100%;
  max-width: 700px;
  min-width: 320px;
  margin: 0 auto;
  margin-top: 30px;
  position: relative;
}
.el-main h2 {
  font-size: 30px;
  color: #fff;
  text-align: center;
}
.el-main .searchTypeList{
  text-align: center;
  margin-top: 20px;
}
.el-main >>> .searchTypeRadio .el-radio-button__inner{
  background: rgba(0, 73, 125, 0.20);
  border-color: rgba(255, 255, 255, 0.2);
  color: #fff;
}
.el-main .el-input-group {
  margin-top: 20px;
}
.el-main .searchTry {
  margin-top: 24px;
  color: #fff;
  font-size: 16px;
}
.el-main .searchTry a {
  text-decoration: underline;
  color: #fff;
  margin-right: 10px;
}
.el-main .searchTry span {
  font-size: 16px;
  font-weight: bold;
}
.el-main .searchTry span a {
  text-decoration: none;
  font-size: 14px;
}
.el-main .searchList {
  position: absolute;
  top: 184px;
  left: 20px;
  width: 60%;
  border-radius: 5px;
  background: #fff;
  padding: 10px;
  max-height: 200px;
  overflow: auto;
}
.el-main .searchList ul li {
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
  padding: 5px;
  cursor: pointer;
}
.el-main .searchList ul li:hover {
  color: #3491FA;
}
.el-main .searchList ul li span {
  width: 80%;
  height: 100%;
}
.el-container >>> .el-main .search-btn-box .el-input-group__append{
  background: #3491FA;
  border: none;
  overflow: hidden;
}
.el-container .el-main >>> button {
  /* background: #3491FA; */
  color: #fff;
  border: none;
  border-radius: none;
}
/* 未登录 */
.el-main .noLogin {
  /* width: 100%; */
  background: rgba(255, 255, 255, 0.4);
  margin-top: 30px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 44px 80px;
}
.el-main .noLogin .toLogin {
  text-align: center;
  flex: 1;
}
.el-main .noLogin .toLogin h2 {
  font-size: 30px;
  color: #006abc;
  font-weight: normal;
}
.el-main .noLogin .toLogin h3 {
  font-size: 24px;
  color: #666666;
  font-weight: normal;
  margin-top: 30px;
}
.el-main .noLogin .toLogin >>> button {
  width: 180px;
  background: #ffa200;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 1);
  margin-top: 30px;
  font-size: 20px;
}
.el-main .noLogin .toLogin >>> button:active {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
}

/* 文献推荐 */
.el-main .recommend {
  width: 100%;
  background: rgba(255, 255, 255, 0.3);
  margin-top: 30px;
  border-radius: 10px;
}
.el-main .recommend h3 {
  width: 95%;
  height: 50px;
  display: flex;
  align-items: center;
  margin: 0 auto;
}
.el-main .recommend h3 {
  width: 95%;
  height: 50px;
  display: flex;
  align-content: center;
  margin: 0 auto;
}
.el-main .recommend h3 span {
  flex: 1;
  font-size: 18px;
  color: #fff;
}
.el-main .recommend h3 >>> button {
  width: 92px;
  height: 30px;
  background: #FFBB0D;
  border-radius: 10px;
  font-size: 14px;
  line-height: 30px;
  padding: 0;
}
.el-main .recommend >>> button:active {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
}
.el-main .recommend ul li {
  /* padding: 20px 0; */
  background: rgba(255, 255, 255, 0.6);
  border-radius: 10px;
  display: flex;
  border-radius: 10px;
  margin-bottom: 4px;
  cursor: pointer;
}
.el-main .recommend ul li div.lside {
  padding: 20px;
  flex: 1;
}
.el-main .recommend ul li div.lside p.title {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #00497d;
}
.el-main .recommend ul li div.lside div.point_text {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #00497d;
  margin-top: 10px;
  font-weight: 400;
}
.el-main .recommend ul li div.lside div.article {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #9a9fa0;
}
.el-main .recommend ul li div.rside {
  width: 44px;
  /* background: rgba(255, 255, 255, 0.5); */
  font-size: 20px;
  color: #00497d;
  display: flex;
  align-items: center;
  justify-content: center;
}
/** overall */
.el-main .overall {
  display: grid;
  grid-template-columns: repeat(3,1fr);
  column-gap: 12px;
  margin-top: 30px;
}
.el-main .overall .overallItem {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 164px;
  padding: 10px 8px;
  box-sizing: border-box;
  background: rgba(255,255,255,0.2);
  border-radius: 8px;
  cursor: pointer;
}
.el-main .overall .overallItem:hover {
  background: rgba(255,255,255,0.3);
}
.el-main .overall .overallItem .arrow .icon {
  width: 24px;
  height: 24px;
}
.el-main .overall .overallItem .arrow {
  width: 24px;
  height: 24px;
  border-radius: 4px;
}
.el-main .overall .overallItem .arrow:hover {
  background: rgba(255,255,255,0.2);
}
.el-main .overall .overallItem .itemInfo {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px 0 10px 10px;
  box-sizing: border-box;
}
.el-main .overall .overallItem .itemInfo img {
  width: 40px;
  height: 40px;
}
.el-main .overall .overallItem .itemInfo .count {
  font-size: 34px;
  color: #FFFFFF;
  font-weight: bold;
}
.el-main .overall .overallItem .itemInfo .name {
  font-size: 16px;
  color: #FFFFFF;
  font-weight: bold;
}
</style>
<style>
/* .el-container .el-main button{
        background: #3491FA !important;
        color:#fff !important;
    } */
.el-container .el-select .el-input {
  width: 130px !important;
}
.el-scrollbar .el-scrollbar__wrap ul li img {
  margin-top: 8px;
  display: block;
}
.el-scrollbar .el-scrollbar__wrap ul li span {
  margin-left: 4px;
}
.el-main .el-input-group__append {
  background: none;
  border-color: rgba(255,255,255,.6);
}
.el-main .el-input-group__append .el-select {
  margin: 0;
  margin-right: 20px;
  margin-top: -10px;
  margin-bottom: -10px;
  margin-left: -20px;
}
.index .codeImg {
  width: 150px;
  position: fixed;
  bottom: 30px;
  left: 30px;
}
.index .iconList {
  z-index: 11111;
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translate(-50%, -50%);
}
.index .iconList .icon {
  width: 50px;
  height: 50px;
  cursor: pointer;
}
.iconImg {
  width: 162px;
  height: 162px;
}
.el-popover {
  min-width: 80px !important;
  padding: 10px !important;
  text-align: center !important;
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue